import React, { useRef, useEffect, useState, useCallback } from 'react'
import "./mobilesearch.css"
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SearchIcon from "@material-ui/icons/Search";
import { debounce } from "lodash";
import axios from "axios";
import API_ENDPOINT from "../../wm.api.service";
import MobilePeopleSearch from './MobilePeopleSearch';
import MobileQuestionSearch from './MobileQuestionSearch';
import MobileBlogSearch from './MobileBlogSearch';
import { connect } from "react-redux";
import { isMobileSearch } from "../../services/actions/actions";
import { MAIN_URL } from '../../config';

function Mobilesearch({ className,isMobileSearchs }) {
    const inputSearch = useRef(null)
    useEffect(() => {
        if(inputSearch.current){
            inputSearch.current.focus();
        }
    },[])
    const [searchData, setSearchData] = useState("");
    const [searchKey, setSearchKey] = useState("");
    const debounceFn = useCallback(debounce(handleDebounceFn, 500), []);
    const searchResult = (e) => {
        setSearchKey(e.target.value);
        debounceFn(e.target.value);
    };
    function handleDebounceFn(inputValue) {
        if (inputValue.length > 0) {
            var fd = new FormData();
            fd.append("search_key", inputValue);
            axios({
                url: `${API_ENDPOINT.apiURL}Profile/search`,
                method: "POST",
                data: fd,
            })
                .then(function (response) {
                    setSearchData(response.data);
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }
    const searchMore = () => {
        if(!searchKey) return null
        if(searchKey){
            window.location.assign(`${MAIN_URL}search?search_query=${searchKey}`)
        }
    }
    return (
        <>
            <div className={`mobileSearch fixed top-0 w-full h-full bg-white ${className}`}>
                <div className="h-full overflow-auto">
                    <div className="w-full h-12 shadow fixed top-0 flex items-center px-2 bg-white z-50">
                        <ArrowBackIcon style={{ color: "var(--color-5)" }} onClick={() => isMobileSearchs(false)}/>
                        <input ref={inputSearch} type="search" id="searchs" autoComplete='off' autoFocus placeholder="Search" className="w-full h-full px-2 py-2" value={searchKey}
                            onChange={(e) => searchResult(e)} />
                        <SearchIcon className="text-gray-500" onClick={() => searchMore()}/>
                    </div>
                    <div className="mt-16 container-fluid pb-10">
                        {/* People */}
                        {searchData?.people?.data.map((peopleData, idx) => {
                            return <MobilePeopleSearch key={idx} peopleData={peopleData} onClick={() => isMobileSearchs(false)}/>
                        })}
                        {/* Blog */}
                        {searchData.blog?.data.length > 0 &&
                            <>
                                <span className="text-2xl manpro font-semibold px-3 my-2 block">Blog</span>
                                {searchData?.blog?.data.map((blogData, idx) => {
                                    return <MobileBlogSearch key={idx} blogData={blogData} onClick={() => isMobileSearchs(false)}/>
                                })}
                            </>
                        }
                        {/* Question */}
                        {searchData.questions?.data.length > 0 &&
                            <>
                                <span className="text-2xl manpro font-semibold px-3 my-2 block">Q&A</span>
                                {searchData?.questions?.data.map((questionData, idx) => {
                                    return <MobileQuestionSearch key={idx} questionData={questionData} onClick={() => isMobileSearchs(false)}/>
                                })}
                            </>
                        }
                    </div>
                    {searchData?.people?.data.length > 0 || searchData.blog?.data.length > 0 || searchData.questions?.data.length > 0 ? <div className="container-fluid mt-3 mb-3">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="search_more text-center p-1">
                                    <a href={`/search?search_query=${searchKey}`} className="bg-gray-300 rounded-md px-12 py-2 color-black manpro text-sm">See More</a>
                                </div>
                            </div>
                        </div>
                    </div> : ''}

                </div>

            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToState = (dispatch) => {
    return {
        isMobileSearchs: (value) => {
            dispatch(isMobileSearch(value));
        },
    };
};
export default connect(mapStateToProps, mapDispatchToState)(Mobilesearch)
